// src/services/foods.js
import { api } from "./api";

// axios POST form helper
function toForm(data) {
  const form = new URLSearchParams();
  Object.entries(data || {}).forEach(([k, v]) => form.append(k, String(v ?? "")));
  return form;
}

// Android: @POST("getkhsaleapp2md.php") (FormUrlEncoded)
export async function fetchKhSaleRows({ mainuser, mobileuser, date1, date2, usertype }) {
  const res = await api.post(
    "getkhsaleapp2md.php",
    toForm({ mainuser, mobileuser, date1, date2, usertype }),
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );
  return res.data; // usually JSON array string
}

// Android: @GET("getkhnameapp4md.php")
export async function fetchKhNames({ mainuser, purdate }) {
  const res = await api.get("getkhnameapp4md.php", {
    params: { mainuser, purdate },
  });
  return res.data; // JSON array string
}

// Android: @POST("savekhsaleapp3md.php") (FormUrlEncoded)
export async function saveKhSale(payload) {
  const res = await api.post(
    "savekhsaleapp3md.php",
    toForm(payload),
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );
  return res.data; // "Saved." / "updated." / etc
}

// ✅ NEW: Android: @GET("getkhpartylistappmd.php")
export async function fetchKhPartyRows({ mainuser }) {
  const res = await api.get("getkhpartylistappmd.php", {
    params: { mainuser },
  });
  return res.data; // JSON array string
}


// ✅ NEW: Android -> savekhpartyappmd.php
export async function saveKhParty(payload) {
  const res = await api.post("savekhpartyappmd.php", toForm(payload), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return res.data; // "Successfully saved." / "Successfully Updated." / "Entry with the same values already exists."
}

export async function fetchKhPartyPaymentList({ mainuser }) {
  const res = await api.get("getkhparypaymentlistmdd2.php", {
    params: { mainuser },
  });
  return res.data; // JSON string array
}

function toFormBody(obj) {
  const p = new URLSearchParams();
  Object.entries(obj || {}).forEach(([k, v]) => p.append(k, v ?? ""));
  return p;
}

/* ---------- Dealer (Party) list ---------- */
export async function fetchKhPartyList({ mainuser }) {
  const res = await api.get("getkhpartylistappmd.php", { params: { mainuser } });
  return res.data; // JSON string array
}

export async function saveKhPartyPayment(payload) {
  const res = await api.post("savekhpartyjmamd.php", toFormBody(payload), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return res.data; // text like "Saved." or "updated."
}